__turbopack_context__.v({
  "container": "XCircle-module__K82Bhq__container",
});
